import * as React from 'react';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { DatePicker as WSRDatePicker } from 'wix-style-react-tpa';
import { TextField, TextFieldTheme } from '../TextField';
import { IconButton } from '../IconButton';
import { Calendar } from '@wix/wix-ui-icons-common/on-stage';
import { st, classes } from './DatePickerInput.deprecated.st.css';
import { DATA_HOOKS } from './constants';
import { ErrorMessageWrapper } from '../internal/ErrorMessageWrapper';
import uniqueId from '../../common/uniqueId';
import { KEYS } from '../../common/keyCodes';
const CustomInput = (props) => {
    const { ownProps: { onClear, onCalendarSuffixButtonClick, 
    // shared props
    disabled, errorMessage, hasError, newErrorMessage, 
    // input props
    inputTheme, isCombobox, label, placeholderText, removeClearButton, 
    // input aria label and labelledby props
    clearButtonAriaLabel, clearButtonAriaLabelledby, dateInputAriaDescribedby, dateInputAriaLabel, dateInputAriaLabelledby, suffixButtonAriaLabel, suffixButtonAriaLabelledby, }, ...rest } = props;
    const injectedProps = rest;
    const { value: formattedValue, onBlur, onChange, onFocus, onInputClicked, onKeyDown, tabIndex, 
    //
    role, ariaControls, ariaExpanded, ariaHasPopup, } = injectedProps;
    return (React.createElement(TextField, { className: classes.textField, "data-hook": DATA_HOOKS.DATE_INPUT, disabled: disabled, error: hasError, errorMessage: !newErrorMessage && errorMessage, inputMode: "none", label: label, newErrorMessage: newErrorMessage, onBlur: onBlur, onChange: isCombobox ? onChange : undefined, onClear: onClear, onClick: onInputClicked, onFocus: onFocus, onKeyDown: isCombobox
            ? onKeyDown
            : (event) => {
                if (event.key === KEYS.Escape || event.key === KEYS.Tab) {
                    onKeyDown(event);
                }
            }, placeholder: placeholderText, readOnly: !isCombobox, suffix: React.createElement(IconButton, { disabled: disabled, "aria-expanded": ariaExpanded, "aria-label": suffixButtonAriaLabel, "aria-labelledby": suffixButtonAriaLabelledby, icon: React.createElement(Calendar, null), onClick: onCalendarSuffixButtonClick }), tabIndex: tabIndex, theme: inputTheme, value: formattedValue.toString(), withClearButton: !removeClearButton, ...(isCombobox
            ? {
                role,
                'aria-autocomplete': 'none',
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
            }
            : {
                'aria-readonly': true,
            }), "aria-describedby": dateInputAriaDescribedby, "aria-label": dateInputAriaLabel, "aria-labelledby": dateInputAriaLabelledby, 
        //
        clearButtonAriaLabel: clearButtonAriaLabel, clearButtonAriaLabelledby: clearButtonAriaLabelledby }));
};
/** The Date pickers presents a calendar and allows a user to select a specific date. */
export class DatePickerInput extends React.Component {
    constructor(props) {
        super(props);
        this._errorMessageId = uniqueId('error-message');
        this.WSRDatePickerRef = React.createRef();
        this._onInputClearButtonClicked = () => {
            const { onChange } = this.props;
            onChange(null);
            this.WSRDatePickerRef.current?.closeCalendar?.();
        };
    }
    render() {
        const { 
        // shared props
        disabled, errorMessage, hasError, newErrorMessage, 
        // wrapper props
        className, errorAppearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 
        // calendar props
        excludePastDates, filterDate, firstDayOfWeek, inputWidth, locale, onChange, onClose, onOpen, popoverAppendTo, popoverPlacement, showMonthDropdown, showYearDropdown, value, zIndex, 
        // calendar aria label and labelledby props
        leftArrowAriaLabel, leftArrowAriaLabelledBy, monthDropdownAriaLabel, monthDropdownAriaLabelledBy, rightArrowAriaLabel, rightArrowAriaLabelledBy, yearDropdownAriaLabel, yearDropdownAriaLabelledBy, autoOpen, } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ rtl }) => {
            const datePickerNode = (React.createElement(WSRDatePicker, { className: classes.wsrDatePicker, customInput: React.createElement(CustomInput, { ownProps: {
                        ...this.props,
                        onClear: this._onInputClearButtonClicked,
                        onCalendarSuffixButtonClick: () => {
                            this.WSRDatePickerRef.current?.openCalendar({
                                autoFocus: true,
                            });
                        },
                    } }), inputProps: {}, dataHook: DATA_HOOKS.WSR_DATE_PICKER, disabled: disabled, excludePastDates: excludePastDates, filterDate: filterDate, firstDayOfWeek: firstDayOfWeek, initialOpen: false, locale: locale, numOfMonths: 1, onChange: (selectedDays) => onChange(selectedDays), onClose: onClose, onOpen: onOpen, popoverProps: {
                    placement: popoverPlacement
                        ? popoverPlacement
                        : rtl
                            ? 'bottom-end'
                            : 'bottom-start',
                    appendTo: popoverAppendTo,
                    dynamicWidth: popoverAppendTo === 'window' ? true : undefined,
                }, rtl: rtl, selectionMode: "day", shouldCloseOnSelect: true, showMonthDropdown: showMonthDropdown, showYearDropdown: showYearDropdown, value: value, width: inputWidth, zIndex: zIndex, ref: this.WSRDatePickerRef, 
                //
                autoOpen: autoOpen, 
                //
                leftArrowAriaLabel: leftArrowAriaLabel, leftArrowAriaLabelledBy: leftArrowAriaLabelledBy, monthDropdownAriaLabel: monthDropdownAriaLabel, monthDropdownAriaLabelledBy: monthDropdownAriaLabelledBy, rightArrowAriaLabel: rightArrowAriaLabel, rightArrowAriaLabelledBy: rightArrowAriaLabelledBy, yearDropdownAriaLabel: yearDropdownAriaLabel, yearDropdownAriaLabelledBy: yearDropdownAriaLabelledBy }));
            const rootClassess = st(classes.root, { newError: hasError && newErrorMessage }, classes.overrideStyleParams, className);
            return newErrorMessage ? (React.createElement(ErrorMessageWrapper, { visible: hasError && !!errorMessage, message: errorMessage, errorAppearance: errorAppearance, messageId: this._errorMessageId, className: rootClassess, "data-hook": this.props['data-hook'] }, datePickerNode)) : (React.createElement("div", { className: rootClassess, "data-hook": this.props['data-hook'], "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy }, datePickerNode));
        }));
    }
}
DatePickerInput.displayName = 'DatePickerInput';
DatePickerInput.defaultProps = {
    disabled: false,
    excludePastDates: false,
    filterDate: () => true,
    hasError: false,
    inputTheme: TextFieldTheme.Box,
    inputWidth: '280px',
    locale: 'en',
    placeholderText: 'MM/DD/YY',
    removeClearButton: false,
    showMonthDropdown: false,
    showYearDropdown: false,
    autoOpen: false,
    isCombobox: false,
};
//# sourceMappingURL=DatePickerInput.js.map